/* Utils */
import { getCdnURl } from '@/utils/getCdnUrl'

/* Types */
import { Mode } from '@/types/main'

import { useNuxtApp, useRuntimeConfig } from '#app'

/**
 * Формируем ссылку на cdn изображений проекта
 * @param src - путь к файлу
 */
export const getImage = (src: string) => {
  const { $pipelineId } = useNuxtApp()
  const { MODE } = useRuntimeConfig().public

  // Eсли это уже ссылка на картинку
  if (src.includes('http')) return { url: src }

  // В Development или если не передан PIPELINE_ID - берем статику из dist
  if (MODE === Mode.DEVELOPMENT || !$pipelineId)
    return { url: `/_nuxt/assets/images${src}` }

  let baseURL = getCdnURl(MODE, $pipelineId)

  // Проверка, вдруг url не будет - берем статику из dist
  if (!baseURL) return { url: src }

  baseURL = `${baseURL}images${src}`

  return { url: baseURL }
}
